import { defineMessages } from 'react-intl';

/** Shared character count for limited text fields (protocols, shortcuts, etc.). */
export const formFieldCharCountMessages = defineMessages({
  charCount: {
    defaultMessage: '{current, number} / {max, number}',
    id: 'Zqb/bssXjf',
    description:
      'Character count for a form field: current length out of maximum allowed',
  },
});
